// @ts-ignore
/* eslint-disable */
import appConfig from "@/appConfig";
import { request } from "@umijs/max";
import qs from "qs";
const apiBaseUrl: any = appConfig?.apiBaseURL;
/** getUserList */
export async function getUserList(body: any) {
  const { current, ...rest } = body;
  const newPostData = {
    ...rest,
    page: current, // current 映射为 page
  };
  return request(apiBaseUrl + "/authApi?url=/user/list", {
    method: "POST",
    data: newPostData,
  });
}

/** getUserRiskList */
export async function getUserRiskList(body: any) {
  const { current, ...rest } = body;
  const newPostData = {
    ...rest,
    page: current,
  };
  return request(apiBaseUrl + "/authApi?url=/user/inviteRiskList", {
    method: "POST",
    data: newPostData,
  });
}
/** inviteRiskTypeList */
export async function inviteRiskTypeList(body: any) {
  const { current, ...rest } = body;
  const newPostData = {
    ...rest,
    page: current,
  };
  return request(apiBaseUrl + "/authApi?url=/user/inviteRiskTypeList", {
    method: "POST",
    data: newPostData,
  });
}

export async function getUserDetail(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/detail", {
    method: "POST",
    data: body,
  });
}

export async function editStatus(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/editStatus", {
    method: "POST",
    data: body,
  });
}

export async function disableUser(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/editStatus", {
    method: "POST",
    data: body,
  });
}

export async function editBalanceAmount(body: any) {
  return request(apiBaseUrl + "/authApi?url=/payment/editBalanceAmount", {
    method: "POST",
    data: body,
  });
}

export async function editBalanceActionTypeList(body: any) {
  return request(
    apiBaseUrl + "/authApi?url=/payment/editBalanceActionTypeList",
    {
      method: "POST",
      data: body,
    }
  );
}

export async function emptyWithdrawLimit(body: any) {
  return request(apiBaseUrl + "/authApi?url=/payment/emptyWithdrawLimit", {
    method: "POST",
    data: body,
  });
}

export async function getMsgTypes(body: any) {
  return request(apiBaseUrl + "/getMsgTypes", {
    method: "POST",
    data: body,
  });
}

export async function getChannelList(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/channelList", {
    method: "POST",
    data: body,
  });
}

export async function createPushMsg(body: any) {
  return request(apiBaseUrl + "/authApi?url=/msg/createPushTask", {
    method: "POST",
    data: body,
  });
}

export async function resetUserPassword(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/resetPassword", {
    method: "POST",
    data: body,
  });
}

export async function setRemarkUser(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/remarkUser", {
    method: "POST",
    data: body,
  });
}

export async function setUserTags(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/editTag", {
    method: "POST",
    data: body,
  });
}

export async function getUserinviteTree(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/inviteTree", {
    method: "POST",
    data: body,
  });
}
export async function setDisableAutoWithdraw(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/disableAutoWithdraw", {
    method: "POST",
    data: body,
  });
}

export async function setResetWhatsappVerify(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/resetWhatsappVerify", {
    method: "POST",
    data: body,
  });
}

export async function setResetCpf(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/resetCpf", {
    method: "POST",
    data: body,
  });
}

export async function editTestAccount(body: any) {
  return request(apiBaseUrl + "/authApi?url=/user/editTestAccount", {
    method: "POST",
    data: body,
  });
}

export async function requestPost(url: any, body: any = {}, opt: any = {}) {
  const { current, ...rest } = body;
  return request(apiBaseUrl + "/authApi?url=" + url, {
    method: "POST",
    data: body,
    ...opt,
  });
}

export async function strapiPost(url: any, body: any = {}, opt: any = {}) {
  const { current, ...rest } = body;
  return request(apiBaseUrl + url, {
    method: "POST",
    data: body,
    ...opt,
  });
}

/** 获取strapi v5系统用户列表 */
export async function getSysUserList(body?: any) {
  return request(apiBaseUrl + "/getSysUserList", {
    method: "POST",
    data: body,
  });
}

/** clearStaticCaches */
export async function clearStaticCaches(body?: any) {
  return request(apiBaseUrl + "/clearStaticCaches", {
    method: "POST",
    data: body,
  });
}

/** clearCDNStaticCaches */
export async function clearCDNStaticCaches(body?: any) {
  return request(apiBaseUrl + "/clearCDNStaticCaches", {
    method: "POST",
    data: body,
  });
}

/** clearAllCDNStaticCaches */
export async function clearAllCDNStaticCaches(body?: any) {
  return request(apiBaseUrl + "/clearAllCDNStaticCaches", {
    method: "POST",
    data: body,
  });
}

export async function getContentManagerList(apiProvider: any, body?: any) {
  let url: any =
    appConfig?.contentManagerApiURL + `/api::${apiProvider}.${apiProvider}`;
  if (Object.keys(body)?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}

export async function getContentManagerRelationsList(
  apiProvider: any,
  paramKey: any,
  body?: any
) {
  let url: any =
    appConfig?.contentManagerRelationsApiURL +
    `/api::${apiProvider}.${apiProvider}${paramKey}`;
  if (Object.keys(body)?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}

export async function addEditContentManagerList(apiProvider: any, body?: any) {
  const { locale, documentId, ...rest } = body;
  let url: any =
    appConfig?.contentManagerApiURL +
    `/api::${apiProvider}.${apiProvider}${
      documentId ? "/" + documentId : ""
    }/actions/publish`;
  if (locale) url += "?locale=" + locale;
  return request(url, {
    method: "POST",
    data: { ...rest },
  });
}

/** addEditVipConfigList */
export async function deleteContentManagerItem(apiProvider: any, body?: any) {
  return request(
    appConfig?.contentManagerApiURL +
      `/api::${apiProvider}.${apiProvider}/${body?.documentId}?locale=*`,
    {
      method: "DELETE",
    }
  );
}

export async function getVipConfigList(body?: any) {
  let url: any =
    appConfig?.contentManagerApiURL + "/api::vip-level-bonus.vip-level-bonus";
  if (Object.keys(body)?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}

export async function addEditVipConfigList(body?: any) {
  const { locale, documentId, ...rest } = body;
  let url: any =
    appConfig?.contentManagerApiURL +
    `/api::vip-level-bonus.vip-level-bonus${
      documentId ? "/" + documentId : ""
    }/actions/publish`;
  if (locale) url += "?locale=" + locale;
  return request(url, {
    method: "POST",
    data: { ...rest },
  });
}

/** addEditVipConfigList */
export async function deleteVipConfigItem(body?: any) {
  return request(
    appConfig?.contentManagerApiURL +
      `/api::vip-level-bonus.vip-level-bonus/${body?.documentId}?locale=*`,
    {
      method: "DELETE",
    }
  );
}
export async function getDepositBonusList(body?: any) {
  let url: any =
    appConfig?.contentManagerApiURL + "/api::deposit-bonus.deposit-bonus";
  if (Object.keys(body)?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}
export async function getDepositBonus(query: any, body?: any) {
  let url: any =
    appConfig?.contentManagerApiURL +
    "/api::deposit-bonus.deposit-bonus/" +
    query?.documentId;
  if (Object.keys(body)?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}
export async function getRelations(query: any, body?: any) {
  const querys = [query?.documentId, query?.field].filter((val) => val);
  let url: any = `${
    appConfig?.baseDomain
  }/content-manager/relations/api::deposit-bonus.deposit-bonus/${querys.join(
    "/"
  )}`;
  if (Object.keys(body)?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}
export async function getDepositBonusConfiguration(body?: any) {
  let url: any =
    appConfig?.baseDomain +
    "/content-manager/content-types/api::deposit-bonus.deposit-bonus/configuration";
  return request(url, {
    method: "GET",
  });
}

export async function getPromotionsList(body?: any) {
  let url: any = appConfig?.contentManagerApiURL + "/api::promotion.promotion";
  if (Object.keys(body)?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}

export async function getPromotion(query: any, body?: any) {
  let url: any =
    appConfig?.contentManagerApiURL +
    "/api::promotion.promotion/" +
    query?.documentId;
  if (Object.keys(body)?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}

export async function getPromotionsConfiguration(body?: any) {
  let url: any =
    appConfig?.baseDomain +
    "/content-manager/content-types/api::promotion.promotion/configuration";
  return request(url, {
    method: "GET",
  });
}

export async function getLeftMenuConfiguration(body?: any) {
  let url: any =
    appConfig?.baseDomain +
    "/content-manager/content-types/api::page-left-menu.page-left-menu/configuration";
  return request(url, {
    method: "GET",
  });
}
